/* eslint-disable @typescript-eslint/no-empty-interface */
import React from 'react';
import { Loader } from 'src/components';
import AssesmentsList from 'src/pages/CandidateAssessments/components/AppliedJobsAssesments';
import styles from './Desktop.module.css';
import { CandidateAssessmentsViewRendererProps } from '../../types';

function Desktop(props: CandidateAssessmentsViewRendererProps) {
  const {
    loading,
    appliedJobs,
    fetchAssessment,
    assessmentFetching,
    assessmentData,
  } = props;
  if (loading) {
    return (
      <div className="top-[50vh] left-[50vw] fixed">
        <Loader />
      </div>
    );
  }

  return (
    <div className={styles.root}>
      <AssesmentsList
        assessmentData={assessmentData}
        appliedJobs={appliedJobs}
        fetchAssessment={fetchAssessment}
        assessmentFetching={assessmentFetching}
      />
    </div>
  );
}

export default Desktop;
